import 'intersection-observer';
import Vue from 'vue';
import App from './App';
import i18n from './i18n';
import router from './router';
import store from './store';
import './core/globals';
import './core/axios';
import './core/common';
import './plugins/analytics';
import './plugins/bugsnag';
import './plugins/casl';
import './plugins/fragment';
import './plugins/meta';
import './plugins/moment';
import './plugins/recaptcha';
import './plugins/vuelidate';
import './plugins/vueNotification';
import vuetify from './plugins/vuetify';
import { initTracking } from './tracking';

// eslint-disable-next-line import/order
import { VTextField, VBtn, VAutocomplete, VSelect, VAlert } from 'vuetify/lib';

// customize config
Vue.config.productionTip = false;

Vue.component('InputCustom', {
  extends: VTextField,
  props: {
    hideDetails: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: true
    },
  },
})

Vue.component('ButtonCustom', {
  extends: VBtn,
  props: {
    // outlined: {
    //   type: Boolean,
    //   default: true
    // },
    elevation: {
      type: [Number, String],
      default: 0
    },
    large: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: true
    },
    rounded: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: Number,
      default: 40
    }
  },
})

// the only difference between AutocompleteCustomFixed and AutocompleteCustom is the attach prop
// It is for dropdown menu to be attached to the input field, also dropdown is shown always under the input field
Vue.component('AutocompleteCustomFixed', {
  extends: VAutocomplete,
  props: {
    hideDetails: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: true
    },
    attach: {
      type: Boolean,
      default: true
    },
  },
})

Vue.component('AutocompleteCustom', {
  extends: VAutocomplete,
  props: {
    hideDetails: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: true
    },
    attach: {
      type: Boolean,
      default: false
    },
  },
})

Vue.component('SelectCustom', {
  extends: VSelect,
  props: {
    hideDetails: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: true
    },
    attach: {
      type: Boolean,
      default: true
    },
  },
})

Vue.component('AlertCustom', {
  extends: VAlert,
  props: {
    outlined: {
      type: Boolean,
      default: true
    },
    elevation: {
      type: Number,
      default: 0
    },
  }
})

// instantiate app
new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');

initTracking();
